var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import DisplayField from "@/components/fields/displayField";
import { isNewRecord } from "@/components/fields/displayField";
import { FieldViewType, screenViewType } from "@/components/fields/viewType";
import logger from "js-logger";
import { useContext, useEffect, useRef, useState } from "react";
import { FormSettingsContext, getColorStyle, getLayoutStyle, getStyleSpacing, scrollToEl, } from "../../utils";
export default function InlineEdit(_a) {
    var name = _a.name, record = _a.record, module = _a.module, label = _a.label, fieldMetadata = _a.fieldMetadata, fieldDefs = _a.fieldDefs, fieldIsUpdated = _a.fieldIsUpdated, validations = _a.validations, fieldSettings = _a.fieldSettings, isStudioField = _a.isStudioField, isSelected = _a.isSelected, layoutParent = _a.layoutParent, viewScreen = _a.viewScreen;
    var _b = useState(FieldViewType.DETAIL), viewType = _b[0], setViewType = _b[1];
    var _c = useState([]), editedRecord = _c[0], setEditedRecord = _c[1];
    //const fieldRef = useRef(null);
    var fieldRef = useRef(null);
    var component = fieldSettings || {};
    var s = component.settings || {};
    var style = s.styles || {};
    useEffect(function () {
        setEditedRecord(record);
    }, [record]);
    /**
     * Hook that alerts clicks outside of the passed ref
     */
    /*function useOutsideAlerter(ref: any) {
      useEffect(() => {
        function handleClickOutside(event: any) {
          if (ref.current && !ref.current.contains(event.target)) {
            setViewType(FieldViewType.DETAIL);
          }
        }
        document
          .getElementById(`detailForm`)
          ?.addEventListener("mousedown", handleClickOutside);
        document
          .getElementById(`previewDetailForm`)
          ?.addEventListener("mousedown", handleClickOutside);
        return () => {
          document
            .getElementById(`detailForm`)
            ?.removeEventListener("mousedown", handleClickOutside);
          document
            .getElementById(`previewDetailForm`)
            ?.removeEventListener("mousedown", handleClickOutside);
        };
      }, [ref]);
    }
  
    useOutsideAlerter(fieldRef);*/
    useEffect(function () {
        function handleClickOutside(event) {
            var target = event.target;
            // Ignore les clics dans le listbox MUI (Select simple ou multiple),
            // qui est rendu dans un Popper en dehors du DOM de fieldRef
            if (target.closest('[role="listbox"]') ||
                target.closest('[role="option"]')) {
                return;
            }
            if (fieldRef.current && !fieldRef.current.contains(event.target)) {
                setViewType(FieldViewType.DETAIL);
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return function () { return document.removeEventListener("mousedown", handleClickOutside); };
    }, [fieldRef]);
    var updateView = function () {
        setViewType(viewType === FieldViewType.DETAIL
            ? FieldViewType.EDIT
            : FieldViewType.DETAIL);
    };
    // Get updated field value
    var fieldUpdated = function (f) {
        logger.debug(">>> DisplayField::fieldUpdated", f[name]);
        fieldIsUpdated(name, f[name]);
    };
    // Studio
    var _d = useContext(FormSettingsContext), settings = _d.settings, editedSettings = _d.editedSettings;
    var refs = useRef(null);
    var onClickComponent = function (e) {
        e.stopPropagation();
        editedSettings(__assign(__assign({}, settings), { target: component.id, component: component, selected: component.id, parentId: layoutParent, type: component.type, currentComponent: component }));
        scrollToEl(refs && (refs === null || refs === void 0 ? void 0 : refs.current));
    };
    // si composant séléctionné
    useEffect(function () {
        isStudioField &&
            settings.selected === component.id &&
            editedSettings(__assign(__assign({}, settings), { target: component.id, type: component.type, component: component, selected: component.id, parentId: layoutParent, currentComponent: __assign(__assign({}, settings.currentComponent), component) }));
    }, [isStudioField && settings.selected]);
    // Spacing style
    var _e = useState([]), styles = _e[0], setStyles = _e[1];
    useEffect(function () {
        var spacingStyle = (s && __assign(__assign({}, getStyleSpacing(style)), getColorStyle(style))) ||
            "";
        setStyles(spacingStyle);
    }, [s]);
    return (_jsx(_Fragment, { children: viewScreen && viewScreen === screenViewType.EDITVIEW ? (_jsx(_Fragment, { children: _jsx("div", __assign({ id: name, className: "flex flex-row justify-start", style: styles }, { children: _jsx(DisplayField, { record: editedRecord, moduleName: module, fieldName: name, viewType: FieldViewType.EDIT, fieldLabel: label, fieldMetadata: fieldMetadata, hideLabel: false, className: "p-1", onUpdate: fieldUpdated, labelClassName: "font-medium", validations: validations, fieldDef: (fieldMetadata &&
                        fieldMetadata.type === "varchar" &&
                        fieldMetadata.group &&
                        fieldMetadata.group !== "email1") ||
                        fieldMetadata.type === "function"
                        ? fieldDefs
                        : {}, viewScreen: viewScreen, isOnStudio: isStudioField }) })) })) : (_jsx(_Fragment, { children: _jsx("div", __assign({ style: styles, ref: function (el) {
                    if (el)
                        refs.current = el;
                }, id: component.id }, { children: _jsx("div", __assign({ className: "flex flex-row justify-start", ref: fieldRef, onClick: function (v) {
                        isStudioField && onClickComponent(v);
                    }, style: getLayoutStyle(isSelected === component.id) }, { children: _jsx(DisplayField, { record: editedRecord, moduleName: module, fieldName: name, viewType: isNewRecord(record) ? FieldViewType.EDIT : viewType, fieldLabel: label, fieldMetadata: fieldMetadata, hideLabel: false, className: "p-1", onUpdate: fieldUpdated, labelClassName: "font-medium", handleEdit: updateView, validations: validations, fieldDef: (fieldMetadata &&
                            fieldMetadata.type === "varchar" &&
                            fieldMetadata.group &&
                            fieldMetadata.group !== "email1") ||
                            fieldMetadata.type === "function"
                            ? fieldDefs
                            : {}, isOnStudio: isStudioField }) })) })) })) }));
}
